<template>
  <div class="participant-activity-response-histroy-list-table">
    <table-component showEmpty noGutters :items="historylist" :fields="formHistoryFields" v-if="historylist" :surveyId="surveyId">
      <!-- date -->
      <template slot="edit_or_completion_time" slot-scope="data">{{ new Date(data.row.item.completion_time_utc) | formatUTCDate }}</template>
      <!-- action -->
      <template slot="eventType" slot-scope="data">
        {{ getAction(data) | CapitalizeFirstLetters }}
        <!-- By -->
      </template>
      <template slot="created_by" slot-scope="data">{{ getName(data) }}</template>
      <!-- view -->
      <template slot="view" slot-scope="data" v-if="!data.row.item.hasOwnProperty('status')">
        <a @click.prevent="view(data.row.item)" href>View</a>
      </template>
    </table-component>
  </div>
</template>

<script>
import TableComponent from "@/components/common/table";
export default {
  name: "participant-activity-response-history-list",
  components: {
    TableComponent
  },
  props: {
    historylist: {
      type: Array,
      default: null
    },
    surveyId: {
      type: String
    },
    participantInfo: {}
  },
  data() {
    return {
      historyview: null,
      formHistoryFields: [
        {
          key: "edit_or_completion_time",
          label: "Date",
          sortable: true
        },
        {
          key: "eventType",
          label: "Action / Changes",
          sortable: false
        },
        {
          key: "created_by",
          label: "By",
          sortable: false
        },
        {
          key: "view",
          label: " "
        }
      ]
    };
  },
  methods: {
    view(item) {
      this.$emit("view", item);
    },
    getAction(data) {
      const action = data.row.item;
      if (action.revision_no == "1.0") {
        return "Original Submission";
      }
      if (action.reason) {
        return action.reason;
      }
      if (action.status) {
        if (action.status === "PENDING") {
          return "Unsigned Off";
        }

        if (action.status === "SIGNEDOFF") {
          return "Signed Off";
        }

        return action.status;
      }
    },
    getName(data) {
      const field = data.row.item;
      if (field.status) {
        return field.modified_by;
      }
      if (field.reason) {
        return field.created_by;
      }
      if (field.revision_no == "1.0") {
        //return this.participantInfo.firstName || this.participantInfo.userDefinedParticipantId;
        return "Participant";
      }
    }
  }
};
</script>
<style lang="scss">
.participant-activity-response-histroy-list-table {
  .custom-b-table table th {
    text-transform: capitalize;
    font-weight: bold;
    font-size: 11px;
  }
  thead {
    background: #f9f9fb;
  }

  table.b-table > tfoot > tr > th.sorting::before,
  table.b-table > thead > tr > th.sorting::before {
    left: 5.75em;
  }
  table.b-table > tfoot > tr > th.sorting::after,
  table.b-table > thead > tr > th.sorting::after {
    left: 5.25em;
  }
}
</style>
